import { admin_question_edit_base } from './admin_question_edit_base';
export class admin_lead_question_edit extends admin_question_edit_base {
    getConfig() {
        return {
            moduleName: 'admin_lead_question_edit',
            headerTitle: 'Partner Lead Question',
            referencesUrl: '/api/admin/rest/api/lead/offer/question/references/',
            questionUrl: '/api/admin/rest/api/lead/offer/question/',
            saveUrl: '/api/admin/rest/api/lead/offer/question/',
            listRoute: '/admin/offerManagement',
            savedRoute: '/admin/leadQuestion/',
            missingSaveMessage: 'Unable to save partner lead question.',
            templateOptions: {
                headerTitle: 'Partner Lead Question',
                newTitle: 'New Partner Lead Question',
                editTitle: 'Edit Partner Lead Question',
                backLabel: 'Back to Partner',
                showDelete: false,
                showQuestionCode: true,
                showDisplayOrder: true,
            },
        };
    }
    getSavePayload() {
        const payload = super.getSavePayload();
        const partnerId = this.getPartnerId();
        if (partnerId > 0) {
            payload.partnerId = partnerId;
        }
        return payload;
    }
    getNewQuestionDefaults() {
        return {
            active: true,
            deletable: false,
            configuration: {},
            answers: [],
        };
    }
    getBackRoute() {
        const partnerId = this.getPartnerId();
        return partnerId > 0 ? '/admin/offerManagement/' + partnerId : '/admin/offerManagement';
    }
    getSavedRoute(questionId) {
        const partnerId = this.getPartnerId();
        const suffix = partnerId > 0 ? '?partnerId=' + partnerId : '';
        return '/admin/leadQuestion/' + questionId + suffix;
    }
    getPartnerId() {
        const partnerId = Number(this.getQueryParam('partnerId') || 0);
        return Number.isFinite(partnerId) ? partnerId : 0;
    }
}
